const TOKEN_KEY = '__TOKEN';
export function getTokenAUTH() {
   return sessionStorage.getItem(TOKEN_KEY);
}